"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NSimulationDTOConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NSimulationDTOConverter, _NotificationDocConve);

  function NSimulationDTOConverter() {
    _classCallCheck(this, NSimulationDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NSimulationDTOConverter).apply(this, arguments));
  }

  return NSimulationDTOConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NSimulationDTOConverter = NSimulationDTOConverter;